<template>
  <div class="mt-4">
    <div class="row">
      <!-- Diabetes Clinic -->
      <div
        v-if="isClinicActive('diabetes')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/diabetes_clinic/diabetes_queue')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">💉</div>
            <h5 class="card-title mb-0">Diabetes Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Cardiology Clinic -->
      <!-- <div
        v-if="package_contains('cardiology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/cardiology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">❤️</div>
            <h5 class="card-title mb-0">Cardiology Clinic</h5>
          </div>
        </div>
      </div> -->

      <!-- ENT Clinic -->
      <div v-if="isClinicActive('ent')" class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/ent_clinic/ent_queue')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">👂</div>
            <h5 class="card-title mb-0">ENT Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Orthopedics Clinic -->
      <div
        v-if="isClinicActive('orthopedics')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/orthopedic_clinic/orthopedic_queue')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🦴</div>
            <h5 class="card-title mb-0">Orthopedics Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Oncology Clinic -->
      <div
        v-if="isClinicActive('oncology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/oncology_clinic/oncology_queue')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🎗️</div>
            <h5 class="card-title mb-0">Oncology Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Dental Clinic -->
      <div
        v-if="isClinicActive('dental')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/dental_clinic/dental_queue')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🦷</div>
            <h5 class="card-title mb-0">Dental Clinic</h5>
          </div>
        </div>
      </div>

      <!-- MCH Clinic -->
      <div v-if="isMchActive()" class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/mch/mch_index')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">👶</div>
            <h5 class="card-title mb-0">MCH Clinic</h5>
          </div>
        </div>
      </div>

      <!-- NEW CLINICS ADDED BELOW -->

      <!-- Dermatology Clinic -->
      <div
        v-if="isClinicActive('dermatology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/dermatology_clinic/dermatology_queue')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🌡️</div>
            <h5 class="card-title mb-0">Dermatology Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Neurology Clinic -->
      <!-- <div
        v-if="package_contains('neurology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/neurology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🧠</div>
            <h5 class="card-title mb-0">Neurology Clinic</h5>
          </div>
        </div>
      </div> -->

      <!-- Ophthalmology Clinic -->
      <div v-if="isClinicActive('eye')" class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/eye_clinic/eye_queue')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">👁️</div>
            <h5 class="card-title mb-0">Eye Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Psychiatry Clinic -->
      <div
        v-if="isClinicActive('phychiatry')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/mental_health_clinic/mental_health_queue')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🧠💭</div>
            <h5 class="card-title mb-0">Psychiatry Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Gastroenterology Clinic -->
      <!-- <div
        v-if="package_contains('gastroenterology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/gastroenterology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🍽️</div>
            <h5 class="card-title mb-0">Gastroenterology Clinic</h5>
          </div>
        </div>
      </div> -->

      <!-- Nephrology Clinic -->
      <!-- <div
        v-if="package_contains('nephrology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/nephrology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🫁</div>
            <h5 class="card-title mb-0">Nephrology Clinic</h5>
          </div>
        </div>
      </div> -->

      <!-- Pulmonology Clinic -->
      <!-- <div
        v-if="package_contains('pulmonology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/pulmonology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🌬️</div>
            <h5 class="card-title mb-0">Pulmonology Clinic</h5>
          </div>
        </div>
      </div> -->

      <!-- Rheumatology Clinic -->
      <!-- <div
        v-if="package_contains('rheumatology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/rheumatology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🦵</div>
            <h5 class="card-title mb-0">Rheumatology Clinic</h5>
          </div>
        </div>
      </div> -->

      <!-- Urology Clinic -->
      <!-- <div
        v-if="package_contains('urology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/urology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🚽</div>
            <h5 class="card-title mb-0">Urology Clinic</h5>
          </div>
        </div>
      </div> -->

      <!-- Endocrinology Clinic -->
      <!-- <div
        v-if="package_contains('endocriminology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/endocrinology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">⚖️</div>
            <h5 class="card-title mb-0">Endocrinology Clinic</h5>
          </div>
        </div>
      </div> -->

      <!-- Pediatrics Clinic -->
      <div
        v-if="isClinicActive('pediatrics')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/pediatrics_clinic/pediatrics_queue')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🚸</div>
            <h5 class="card-title mb-0">Pediatrics Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Physiotherapy Clinic -->
      <div
        v-if="isClinicActive('physiotherapy')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/physiotherapy_clinic/physiotherapy_queue')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">💪</div>
            <h5 class="card-title mb-0">Physiotherapy Clinic</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import package_contains from "./package_contains";
import { generalApiRequest } from "../../api/apiIndex";

// Clinics with a real row in the `clinics` table - these are gated by
// the company_clinics configuration instead of the old package system.
const CLINIC_IDS = {
  diabetes: 8,
  ent: 13,
  orthopedics: 15,
  oncology: 21,
  dental: 12,
  dermatology: 23,
  eye: 14,
  phychiatry: 19,
  pediatrics: 2,
  physiotherapy: 16,
};
// MCH covers several clinics table rows - the card shows if any is active.
const MCH_CLINIC_IDS = [3, 4, 5, 6, 7]; // ANC, Maternity, PNC, CWC, Family Planning

export default {
  name: "SpecialClinicsMenu",
  data() {
    return {
      activeClinicIds: [],
      loadedActiveClinics: false,
    };
  },
  mounted() {
    this.fetchActiveClinics();
  },
  methods: {
    package_contains,
    goToClinic(route) {
      this.$router.push(route);
    },
    async fetchActiveClinics() {
      try {
        const response = await generalApiRequest(
          "company_clinics/active",
          "GET",
          {},
          1,
        );
        if (response.success) {
          this.activeClinicIds = response.active_clinic_ids || [];
        }
      } catch (error) {
        console.error("Error fetching active company clinics:", error);
      } finally {
        this.loadedActiveClinics = true;
      }
    },
    // A clinic with a real clinics-table id is only shown once the
    // company_clinics list has loaded and includes it. Clinics that
    // don't have a matching row in the clinics table (yet) keep using
    // the older package-based check below.
    isClinicActive(key) {
      const id = CLINIC_IDS[key];
      if (!id) return this.package_contains(key);
      return this.loadedActiveClinics && this.activeClinicIds.includes(id);
    },
    isMchActive() {
      return (
        this.loadedActiveClinics &&
        MCH_CLINIC_IDS.some((id) => this.activeClinicIds.includes(id))
      );
    },
  },
};
</script>

<style scoped>
.clinic-card {
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  border: 2px solid transparent;
}
.clinic-card:hover {
  transform: translateY(-5px);
  border-color: #007bff;
  background-color: rgba(247, 202, 202, 0.5);
}
.clinic-icon {
  font-size: 3rem;
}
/* Responsive adjustments */
@media (max-width: 768px) {
  .clinic-icon {
    font-size: 2.5rem;
  }
  h5.card-title {
    font-size: 1rem;
  }
}
</style>
